import { z } from 'zod';

import { isoDatetimeToDate, stringToUuidArray } from '../codecs';

export type CalibrationsQuery = z.output<typeof calibrationsQuerySchema>;
export type CalibrationsQueryDTO = z.input<typeof calibrationsQuerySchema>;

export const calibrationsQuerySchema = z.object({
  cameraIds: stringToUuidArray.optional(),
  from: isoDatetimeToDate.optional(),
  to: isoDatetimeToDate.optional(),
  validAfter: isoDatetimeToDate.optional(),
  validBefore: isoDatetimeToDate.optional(),
});
